import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const GET_CUSTOMER_LIST_EXPORT = 'GET_CUSTOMER_LIST_EXPORT';
export const GET_CUSTOMER_LIST_EXPORT_SUCCESS =
  'GET_CUSTOMER_LIST_EXPORT_SUCCESS';
export const GET_CUSTOMER_LIST_EXPORT_FAILURE =
  'GET_CUSTOMER_LIST_EXPORT_FAILURE';

// Action Creators
export const fetchGetCustomerExport = () => ({
  type: GET_CUSTOMER_LIST_EXPORT,
});

export const fetchGetCustomerExportSuccess = (data) => ({
  type: GET_CUSTOMER_LIST_EXPORT_SUCCESS,
  payload: data,
});

export const fetchGetCustomerExportFailure = (error) => ({
  type: GET_CUSTOMER_LIST_EXPORT_FAILURE,
  payload: error,
});

// Thunk Function
export const getCustomerExportCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetCustomerExport(data, external));
    try {
      const response = await getMethodWithToken(
        url.getCustomerDataSuperAdmin + '?type=download'
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetCustomerExportSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetCustomerExportFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetCustomerExportFailure(error.message));
    }
  };
};
